"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/**
 * @module ol/ViewHint
 */

/**
 * @enum {number}
 */
var _default = {
  ANIMATING: 0,
  INTERACTING: 1
};
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBOzs7O0FBSUE7OztlQUdlO0VBQ2JBLFNBQVMsRUFBRSxDQURFO0VBRWJDLFdBQVcsRUFBRTtBQUZBLEMiLCJuYW1lcyI6WyJBTklNQVRJTkciLCJJTlRFUkFDVElORyJdLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJzcmMvVmlld0hpbnQuanMiXSwic291cmNlc0NvbnRlbnQiOltudWxsXX0=